module.exports = __webpack_public_path__ + "static/media/HEROMOTOCO.d917660a.txt";